import React from 'react'
import PropTypes from 'prop-types'
import Assign from 'object-assign'
import styles from './styles'
import { Sizes, Colours } from '../../style_helpers'

const ChevronIcon = (props) => {
  const style = Assign({}, styles.rotate(props.rotateDegrees), props.style)
  return (
    <svg width={props.width} height={props.height} style={style} viewBox='0 0 8 11' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
      <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd' opacity='1'>
        <g transform='translate(-71.000000, -5.000000)' fillRule='nonzero' fill={props.colour}>
          <path d='M70.2928932,9.12435786 L74.2928932,13.3089732 C74.6834175,13.7175217 75.3165825,13.7175217 75.7071068,13.3089732 L79.7071068,9.12435786 C80.0976311,8.71580937 80.0976311,8.0534214 79.7071068,7.64487291 C79.3165825,7.23632442 78.6834175,7.23632442 78.2928932,7.64487291 L74.2928932,11.8294883 L75.7071068,11.8294883 L71.7071068,7.64487291 C71.3165825,7.23632442 70.6834175,7.23632442 70.2928932,7.64487291 C69.9023689,8.0534214 69.9023689,8.71580937 70.2928932,9.12435786 L70.2928932,9.12435786 Z' transform='translate(75.000000, 10.476923) rotate(-90.000000) translate(-75.000000, -10.476923) ' />
        </g>
      </g>
    </svg>
  )
}

ChevronIcon.defaultProps = {
  width: Sizes(-7),
  height: Sizes(-5),
  colour: Colours('grey', '300'),
  rotateDegrees: 0
}

ChevronIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  colour: PropTypes.string,
  rotateDegrees: PropTypes.number
}

export default ChevronIcon
